import React, { useEffect } from 'react';
import MenuNav from './MenuNav';
import { FaAngleLeft, FaAngleRight, FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../components/Config/api.service';
import yrosLogo from '../../assets/yros_logo.png';
import LanguageSwitcher from '../Header/LanguageSwitcher';
import { trierSocietes } from './trierSocietes';

const SidebarNav = ({ isCollapsed, setIsCollapsed, onLogoutRequest }) => {
  const { t } = useTranslation();
  const [currentUser, setCurrentUser] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch (error) {
      return {};
    }
  });
  const [companyLogoSrc, setCompanyLogoSrc] = React.useState(() => {
    try {
      const info = JSON.parse(localStorage.getItem('companyInfo') || 'null');
      if (info && info.logo) return `data:image/png;base64,${info.logo}`;
    } catch (e) {}
    return null;
  });
  const [companies, setCompanies] = React.useState([]);
  const [multicompany, setMulticompany] = React.useState(false);
  const [activeCompanyId, setActiveCompanyId] = React.useState(null);
  const [activeCompanyName, setActiveCompanyName] = React.useState('');
  const [showDropdown, setShowDropdown] = React.useState(false);

  const isConnected = localStorage.getItem('isConnected');

  useEffect(() => {
    // Charger la préférence de l'utilisateur pour la sidebar
    const sidebarState = localStorage.getItem('sidebarCollapsed');
    if (sidebarState) {
      setIsCollapsed(sidebarState === 'true');
    }

    // Forcer le collapsed sur mobile
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsCollapsed(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    const fetchCompanies = async () => {
      try {
        const response = await apiService.getElement('/user');
        const user = response.data.user;
        const comps = user.company_ids || [];
        const sortedComps = trierSocietes(comps);

        localStorage.setItem('user', JSON.stringify(user));
        setCurrentUser(user);
        setMulticompany(user.multicompany);
        setCompanies(sortedComps);
        setActiveCompanyId(user.company_active.id);
        setActiveCompanyName(user.company_active.name);
          // update companyInfo if present in response
          try {
            if (response.data && response.data.company_active && response.data.company_active.logo) {
              const ci = { ...response.data.company_active };
              localStorage.setItem('companyInfo', JSON.stringify(ci));
              setCompanyLogoSrc(ci.logo ? `data:image/png;base64,${ci.logo}` : null);
            }
          } catch (e) {}
      } catch (error) {
        console.error('Erreur lors de la récupération des sociétés :', error);
      }
    };

    if (isConnected) {
      fetchCompanies();
    }

      const onCompanyChanged = () => {
        try {
          const info = JSON.parse(localStorage.getItem('companyInfo') || 'null');
          setCompanyLogoSrc(info && info.logo ? `data:image/png;base64,${info.logo}` : null);
        } catch (e) {}
      };
      window.addEventListener('companyChanged', onCompanyChanged);
    return () => {
      window.removeEventListener('resize', handleResize);
        window.removeEventListener('companyChanged', onCompanyChanged);
    };
  }, [isConnected, setIsCollapsed]);

  // Fonction pour basculer l'état de la sidebar
  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', newState.toString());
  };

  const handleCompanyChange = async (newCompanyId) => {
    try {
      const response = await apiService.saveElement(`/switch_company/${newCompanyId}`, {});
      const { active_company_name, active_company_id, companies: switchComps } = response.data;

      const sortedComps = trierSocietes(switchComps || []);

      setActiveCompanyId(active_company_id);
      setActiveCompanyName(active_company_name);
      setCompanies(sortedComps);
      localStorage.setItem('companyName', active_company_name);
      setShowDropdown(false);
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors du changement de société :', error);
    }
  };

  if (!isConnected) {
    return null;
  }

  return (
    <div>
      <div
        className={`fixed top-0 left-0 bottom-0 bg-[--color-primary] z-50 flex flex-col ${
          isCollapsed ? 'w-[70px]' : 'w-[250px]'
        } overflow-hidden transition-all duration-300 ease-in-out`}
      >
        {/* Header: company + logo */}
        <div className=" cursor-pointer">
          
          <div className="flex justify-between items-center p-4 relative">
            <div className="flex items-center gap-2 min-w-0 w-full">
              <button type="button" className="text-center py-2 text-white font-bold shrink-0" onClick={() => multicompany && setShowDropdown(!showDropdown)}>
                <img src={companyLogoSrc || yrosLogo} alt="Logo" className="w-12 h-12 mx-auto bg-gradient-to-r from-orange-500 to-yellow-500 rounded-lg object-cover" />
              </button>
              {!isCollapsed && (
                <button
                  type="button"
                  className="flex items-start gap-1 cursor-pointer hover:opacity-90 transition-opacity min-w-0 flex-1 text-left"
                  onClick={() => multicompany && setShowDropdown(!showDropdown)}
                  title={activeCompanyName}
                >
                  <span className="text-base lg:text-lg text-white font-bold leading-tight whitespace-normal break-words">
                    {activeCompanyName}
                  </span>
                  {multicompany && <FaChevronDown className="text-white opacity-80 mt-1 shrink-0" size={14} title={t('sidebar.changeCompany')} />}
                </button>
              )}
            </div>

            {showDropdown && (
              <div
                className={`fixed top-20 left-[80px] bg-white shadow-lg rounded w-[220px] z-[9999] max-h-[60vh] overflow-y-auto overscroll-contain`}
                // top-20: below the sidebar header; left-[80px]: right next to collapsed sidebar
                // max-h-[60vh] + overflow-y-auto: la liste peut dépasser l'écran quand
                // l'utilisateur a beaucoup de sociétés (#295) — sans ça elle débordait
                // sans possibilité de scroll.
              >
                <div className="p-2 text-gray-700 text-center font-semibold sticky top-0 bg-white">{t('sidebar.changeCompany')}</div>
                {companies.map((company) => {
                  const isChild = company.parent_id && company.parent_id !== 1;
                  return (
                  <button
                    type="button"
                    key={company.id}
                    className={`w-full text-left p-2 cursor-pointer hover:bg-gray-200 transition-colors flex items-center ${
                      company.id === activeCompanyId ? 'font-bold text-[--color-primary] bg-orange-50' : 'text-gray-700'
                    } ${isChild ? 'pl-6 text-sm' : 'font-semibold'}`}
                    onClick={() => {
                        if (company.id !== activeCompanyId) handleCompanyChange(company.id);
                    }}
                  >
                    {isChild ? (
                       <span className="flex items-center gap-2">
                          <span className="text-gray-400">↳</span>
                          <span>{company.name}</span>
                       </span>
                    ) : (
                       <span>{company.name}</span>
                    )}
                  </button>
                )})}
              </div>
            )}
          </div>
        </div>

        {/* Scrollable menu */}
        <div className="flex-1 text-center overflow-y-auto mt-4">
          <MenuNav
            isCollapsed={isCollapsed}
            onLogoutRequest={onLogoutRequest}
            user={currentUser}
          />
        </div>

        {/* Footer / toggle */}
        <div className={`hidden lg:flex p-4 ${isCollapsed ? 'flex-col items-center gap-2' : 'items-center justify-between'}`}>
          {!isCollapsed && <LanguageSwitcher />}
          <button
            onClick={toggleSidebar}
            className="bg-gradient-to-r from-orange-500 to-yellow-500 text-white rounded-full p-2 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-400 transition-colors"
            aria-label={isCollapsed ? t('sidebar.expandSidebar') : t('sidebar.collapseSidebar')}
          >
            {isCollapsed ? <FaAngleRight /> : <FaAngleLeft />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidebarNav;
